import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Image, Modal } from 'react-bootstrap';
import { IoArrowBackOutline, IoCreateOutline, IoDocumentTextOutline, IoTrashOutline } from 'react-icons/io5';
import imgPlaceholder from '../../../../assets/images/placeholder/customer-image-placeholder.png';
import OutletHead from '../../../../components/common/outlet-head';
import { db } from '../../../../firebase';
import { deleteDoc, doc } from 'firebase/firestore';

const PartyDetails = () => {

  const location = useLocation();
  let navigate = useNavigate();

  const [data, setData] = useState(null);
  const [item, setItem] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  const handleClose = () => setShowDelete(false);
  const handleShow = () => setShowDelete(true);

  useEffect(() => {
    let { state } = location;
    setData(state.data);
    setItem(state.items);
  }, [location]);

  async function handleDeleteItem() {
    await deleteDoc(doc(db, "Parties", item.id));
    navigate('/admin/parties');
  }

  return (
    <section className='section'>
      <div className='row'>
        <div className='col-md-3 col-12 pe-0'>
          <div className='sub-nav border-end'>
            <div className='sub-nav-head top-sticky p-3'>
              <Form.Control
                placeholder='Search'
                onChange={(event) => setSearchText(event.target.value.toLowerCase())}
                value={searchText}
              />
            </div>
            <div className='sub-nav-items p-3 pt-0'>
              {
                data && data.map((dataItem, index) => {
                  return (
                    <button
                      key={index}
                      className={dataItem.id === item.id ? 'btn-subnav bg-light border-light mt-3 w-100' : 'btn-subnav mt-3 w-100'}
                      onClick={() => setItem(dataItem)}
                    >
                      <h6 className='mb-0'>{dataItem.partyName}</h6>
                      <p className='mb-0 text-muted'><small>{dataItem.fatherHusband}</small></p>
                    </button>
                  )
                })
              }
            </div>
          </div>
        </div>
        <div className='col-md-9 col-12 ps-0'>
          <OutletHead
            left={
              <div className='d-flex align-items-center'>
                <Button
                  variant='light'
                  size='sm'
                  className='p-2 me-3 rounded-circle'
                  onClick={() => navigate(-1)}
                >
                  <IoArrowBackOutline size={24} />
                </Button>
                <h5 className='mb-0 fw-600'>{item && item.partyName}</h5>
              </div>
            }
            right={
              <div className='d-flex align-items-center justify-content-end'>
                <Button
                  variant="outline-primary"
                  type="button"
                  className='py-2 px-4 me-3'
                >
                  <IoDocumentTextOutline size={20} />
                  <span className='ps-2'>Export</span>
                </Button>
                <Link
                  to="../edit"
                  state={item}
                >
                  <Button
                    variant="outline-success"
                    type="button"
                    className='py-2 px-3 me-3'
                  >
                    <IoCreateOutline size={20} />
                    <span className='ps-2'>Edit</span>
                  </Button>
                </Link>
                <Button
                  variant="outline-danger"
                  type="button"
                  className='py-2 px-3'
                  onClick={handleShow}
                >
                  <IoTrashOutline size={20} />
                  <span className='ps-2'>Delete</span>
                </Button>
              </div>
            }
          />
          <div className='inner-wrapper p-3 border-top'>
            {
              item && item ?
                <div className='row'>
                  <div className='col-lg-12 col-md-9 col-12'>
                    <div className='mb-4'>
                      <div className='row'>
                        <div className='col-lg-3 col-md-3 col-12'>
                          <div className='mb-4'>
                            <div className='profile-image'>
                              <Image
                                src={item.photo ? item.photo : imgPlaceholder}
                                alt='party-photo'
                                fluid
                                thumbnail
                                rounded
                              />
                            </div>
                          </div>
                        </div>
                        <div className='col-lg-9 col-md-9 col-12'>
                          <div className='row border-bottom mb-3'>
                            <div className='col-lg-12 col-md-12 col-12'>
                              <div className='info-tag mb-3'>
                                <span>Party Name</span>
                                <div className='d-flex align-items-center'>
                                  <h4 className='mb-0 me-3'>{item.partyName ? item.partyName : "-"}</h4>
                                  {
                                    item.partyType && item.partyType === "Customer" ?
                                      <Alert variant="success" className='p-0 m-0 text-success fw-normal rounded px-2 small'>
                                        {item.partyType}
                                      </Alert>
                                      :
                                      <Alert variant="danger" className='p-0 m-0 text-success fw-normal rounded px-2'>
                                        <small>{item.partyType}</small>
                                      </Alert>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Father's/Husband's</span>
                                <p>{item.fatherHusband ? item.fatherHusband : "-"}</p>
                              </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Date of Birth</span>
                                <p>{item.dob ? item.dob : "-"}</p>
                              </div>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Gender</span>
                                <p className='text-capitalize'>{item.gender ? item.gender : "-"}</p>
                              </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Occupation</span>
                                <p>{item.occupation ? item.occupation : "-"}</p>
                              </div>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Aadhar Number</span>
                                <p>{item.aadharNumber ? item.aadharNumber : "-"}</p>
                              </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Pan Number</span>
                                <p>{item.panNumber ? item.panNumber : "-"}</p>
                              </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>GST Number</span>
                                <p>{item.gst ? item.gst : "-"}</p>
                              </div>
                            </div>
                          </div>
                          <h5 className='info-head mb-3 mt-3'>Contact Information</h5>
                          <div className='row'>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Phone Number</span>
                                <p>+91 {item.phoneNumber ? item.phoneNumber : "-"}</p>
                              </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Alternate Number</span>
                                <p>+91 {item.alternatePhoneNumber ? item.alternatePhoneNumber : "-"}</p>
                              </div>
                            </div>
                          </div>
                          <div className='row'>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Address</span>
                                <p className='mb-0'>{item.address ? item.address + ", " : ""}{item.city ? item.city + ", " : ""}{item.pincode ? item.pincode + ", " : ""}</p>
                                <p>{item.state ? item.state + ", " : ""}{item.country ? item.country : ""}</p>
                              </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-12'>
                              <div className='info-tag'>
                                <span>Email Address</span>
                                <p className='mb-0'>{item.email ? item.email : "-"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='border p-3 mb-5 position-relative'>
                      <h5 className='info-head mb-3'>Booking Information</h5>
                      <div>
                        Party Booking Details
                      </div>
                    </div>
                  </div>
                </div>
                :
                null
            }
          </div>
        </div>
      </div>

      <Modal
        show={showDelete}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='mb-0 text-center'>Are you sure, you want to delete?</h5>
        </Modal.Body>
        <Modal.Footer className='justify-content-center'>
          <Button
            variant="outline-dark"
            onClick={handleClose}
            className='px-5 py-2'
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className='px-5 py-2'
            onClick={handleDeleteItem}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}

export default PartyDetails;
